import AspectRatioComponent from "components/aspect-ratio";
import Image from "next/image";
import { Button } from "components/ui/button";
import { LinkTrackers } from "~/components/reusables/link-trackers";

export function QRNGBannerV2() {
  return (
    <div className="relative">
      <div className="relative overflow-hidden rounded-xl border border-white bg-[#1C0E2A]">
        <div className="absolute bottom-0 right-0 z-10 w-full">
          <AspectRatioComponent aspectRatio={{ width: 300, height: 600 }}>
            <Image
              unoptimized
              src="/images/pages/qrng/qrng-blog-banner-bg.png"
              fill
              alt="BG"
              className=""
            />
          </AspectRatioComponent>
        </div>
        <div className="relative z-20 px-[20px] pb-16 pt-10 text-white ">
          <div className={"w-11/12 max-w-64 pb-8 lg:w-full lg:max-w-64"}>
            <AspectRatioComponent aspectRatio={{ width: 258, height: 28 }}>
              <Image
                unoptimized
                src="/images/logos/quantum/qrng-header-logos.png"
                fill
                alt="Logo"
                className=""
              />
            </AspectRatioComponent>
          </div>
          <h2 className="font-h3 font-normal mb-3 bg-gradient-to-r from-[#94E147] to-[#09C0E9] bg-clip-text text-transparent md:text-[31px] ">
            Power AI, secure data, and drive breakthroughs with true randomness.
          </h2>
          <p className="font-p font-thin pt-4 lg:max-w-64">
            Request access to Outshift's free QRNG API access!
          </p>
          <div className="flex py-12">
            <div className="group relative">
              <Button
                aria-label="button"
                variant={"outline"}
                className="bg-qrng-purple-900/60 rounded-lg text-white hover:bg-qrng-purple-200 hover:text-white"
              >
                <LinkTrackers
                  href="/quantum-random-number-generator"
                  className="font-p-sm flex items-center gap-2"
                  segmentMsg="Banner Link Clicked"
                  segmentOpt={{
                    link_label: "Get started",
                    location: "banner",
                    location_detail: "right-header",
                    resource_interaction: "visit the QRNG page",
                  }}
                >
                  Get started
                </LinkTrackers>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
